export default "assets/images/player-ec8bc85f.png";